





















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import BSwitch from "@/components/app/switchs/b-switch.vue";
import BSettingDd from "@/components/app/shared/btn&dd/b-setting-dd.vue";

interface IPlaylist {
  _id: string;
  name: string;
  show: boolean;
  description?: string;
  src?: { cover?: string };
  createdAt: string;
  trackCount: number;
}

@Component({ components: { BSwitch, BSettingDd } })
class PlaylistTableCard extends Vue {
  @Prop({ type: Object, default: null }) playlist!: IPlaylist;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;

  coverError = false;

  get getCover(): string {
    return this.playlist.src?.cover || "";
  }

  get showCover(): boolean {
    return !!this.getCover && !this.coverError;
  }

  @Watch("getCover")
  onCoverChange(): void {
    this.coverError = false;
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    return d.toLocaleDateString(this.$i18n.locale, {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }
}
export default PlaylistTableCard;
